import axiosInstance from "../utils/axios";

export class AnalyticsService {
    getRecallFunnel() {
        return axiosInstance.get(`/communication-analytics/recall-funnel`);
    }

    getCampaignPerformance(id: string) {
        return axiosInstance.get(`/communication-analytics/campaign/${id}/performance`);
    }

    getPatientCommunicationHistory(id: string) {
        return axiosInstance.get(`/communication-analytics/patient/${id}/history`);
    }
}

export const analyticsService = new AnalyticsService();
